<template>
  <v-container fluid class="ncrm-record-layout">
    <slot name="header" />

    <v-row class="mt-4 ncrm-record-layout__row" dense align="stretch">
      <v-col
        v-if="$slots.left"
        cols="12"
        :lg="leftLgCols"
        class="ncrm-record-layout__col ncrm-record-layout__col--left"
        :style="mobileLeftOrderStyle"
      >
        <slot name="left" />
      </v-col>

      <v-col
        cols="12"
        :lg="mainLgCols"
        class="ncrm-record-layout__col ncrm-record-layout__col--main"
        :style="mobileMainOrderStyle"
      >
        <slot name="main">
          <slot />
        </slot>
      </v-col>

      <v-col
        v-if="$slots.right"
        cols="12"
        :lg="rightLgCols"
        class="ncrm-record-layout__col ncrm-record-layout__col--right"
        :style="mobileRightOrderStyle"
      >
        <slot name="right" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { computeNcrmRecordMainLgCols } from "@/Utile/ncrmRecordShell.mjs";

export default {
  name: "NcrmRecordLayout",
  props: {
    leftLgCols: {
      type: [Number, String],
      default: 2,
    },
    rightLgCols: {
      type: [Number, String],
      default: 2,
    },
    mainLgColsBoth: {
      type: [Number, String],
      default: 8,
    },
    mainLgColsSingleSide: {
      type: [Number, String],
      default: 10,
    },
    mobileMainOrder: {
      type: [Number, String],
      default: 1,
    },
    mobileLeftOrder: {
      type: [Number, String],
      default: 2,
    },
    mobileRightOrder: {
      type: [Number, String],
      default: 3,
    },
  },
  computed: {
    hasLeftSlot() {
      return Boolean(this.$slots.left);
    },
    hasRightSlot() {
      return Boolean(this.$slots.right);
    },
    mainLgCols() {
      return computeNcrmRecordMainLgCols({
        hasLeftSlot: this.hasLeftSlot,
        hasRightSlot: this.hasRightSlot,
        mainLgColsBoth: this.mainLgColsBoth,
        mainLgColsSingleSide: this.mainLgColsSingleSide,
      });
    },
    mobileMainOrderStyle() {
      return {
        "--ncrm-mobile-order": String(this.mobileMainOrder),
      };
    },
    mobileLeftOrderStyle() {
      return {
        "--ncrm-mobile-order": String(this.mobileLeftOrder),
      };
    },
    mobileRightOrderStyle() {
      return {
        "--ncrm-mobile-order": String(this.mobileRightOrder),
      };
    },
  },
};
</script>

<style scoped>
.ncrm-record-layout {
  text-align: left;
  background-color: var(--ncrm-color-page-background);
  min-height: calc(100vh - var(--v-layout-top, 0px));
}

.ncrm-record-layout__row {
  min-height: calc(100vh - var(--v-layout-top, 0px) - 80px);
}

.ncrm-record-layout__col {
  display: flex;
  flex-direction: column;
}

.ncrm-record-layout__col > :deep(*) {
  flex: 1;
  min-height: 0;
}

@media (max-width: 959px) {
  .ncrm-record-layout__col {
    order: var(--ncrm-mobile-order, 0);
  }
  .ncrm-record-layout__row {
    min-height: unset;
  }
}
</style>
